import React, {FC, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {IProductProps, productActionType} from '../../cors/reducers'
import SharedData from '../../../common/SharedData'
import {validateImages} from '../../cors/_requests'
import SortableImages from '../../components/SortableImages'
import {fileOf, variationImageList} from '../../utils/productImages'

const ProductMoreImagesVariations: FC<IProductProps> = ({prodState, prodDispatch, index, closePopup}) => {
  const {formatMessage} = useIntl()
  const {currentUser, language} = SharedData()
  const sindex = index ?? 0
  const variation = prodState.variationImages[sindex]
  const images = useMemo(() => variationImageList(variation), [variation])
  const [error, setError] = useState('')

  const updateImages = (ordered: any[]) => {
    const first = ordered[0]
    setError('')
    prodDispatch({type: productActionType.updateVariationImages, payload: {
      index: sindex,
      image: {value: first instanceof File ? first : first?.image || first || '', error: false, msg: ''},
      product_image: ordered,
    }})
  }

  const saveImages = async () => {
    const files = images.map(fileOf).filter((file): file is File => !!file)
    try {
      if (files.length) await validateImages(language, currentUser?.token, files)
      closePopup?.()
    } catch (error: any) {
      const details = error.response?.data?.error
      setError(Array.isArray(details) ? details.join('\n') : typeof details === 'string' ? details : formatMessage({id: 'image_error_fields'}))
    }
  }

  return <SortableImages images={images} onChange={updateImages} error={error}>
    <button type='button' className='btn btn-primary d-flex m-auto mt-5' onClick={saveImages}>{formatMessage({id: 'upload_img'})}</button>
  </SortableImages>
}

export default ProductMoreImagesVariations
